import { joinCruz } from './joinCruz'
import { requestVerificationEmail } from './requestVerificationEmail'
import { activateAccountByToken } from './activeAccountByToken'
import { signIn, signInWithGoogle, signInWithApple, signInWithFacebook } from './signIn'
import { renewAccessToken } from './token'
import { forgotPassword, resetPassword } from './password'

export const authApi = {
  joinCruz,
  requestVerificationEmail,
  activateAccountByToken,
  signIn,
  signInWithGoogle,
  signInWithApple,
  signInWithFacebook,
  renewAccessToken,
  forgotPassword,
  resetPassword,
}